import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "button primary" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "loader button-loader"
}

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { fetchWithAuth } from '@/utils/api';
import { type Dish } from '@/types';
import DishListSelector from './DishListSelector.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddDishForm',
  props: {
    show: { type: Boolean }
  },
  emits: ["hideForm", "dishAdded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const apiUrl = computed(() => store.getters.getApiUrl);

// Form fields
const title = ref('');
const goal = ref<number | null>(null);
const description = ref('');
const list = ref<string>('current'); // Default to 'current' list
const loading = ref(false);

// Hide form
const hideForm = () => {
  emit('hideForm');
};

const dishListSelectChangeHandler = (listId: string) => {
  list.value = listId;
};

// Reset form
const resetForm = () => {
  title.value = '';
  goal.value = null;
  description.value = '';
  list.value = 'current';
};

const handleForm = async () => {
  if (!title.value || goal.value === null) {
    alert('Please fill in both title and goal fields before submitting.');
    return;
  }

  try {
    loading.value = true;
    const response = await fetchWithAuth(
      `${apiUrl.value}/api/dishes`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: title.value,
          goal: goal.value,
          description: description.value,
          list: list.value,
        }),
      },
      store
    );

    if (response.ok) {
      const response_json = await response.json();
      const dishId = Number(response_json.dishId);

      const newDish = {
        id: dishId,
        title: title.value,
        description: description.value,
        goal: goal.value,
        list: list.value,
        logs: [],
      };

      emit('dishAdded', newDish);
      resetForm();
    } else {
      const errorData = await response.json().catch(() => ({}));
      alert(`Failed to add dish: ${errorData.error || 'Unknown error'}`);
    }
    loading.value = false;
  } catch (error) {
    loading.value = false;
    console.error('An error occurred while adding the dish:', error);
    alert('An unexpected error occurred. Please try again later.');
  }
};

const isHiding = ref(false);

watch(() => props.show, (newVal) => {
  if (!newVal) {
    isHiding.value = true;
    setTimeout(() => {
      isHiding.value = false;
    }, 300); // Match your transition time (0.3s)
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["add-dish-form-container slide-up-form", { show: _ctx.show, hiding: isHiding.value }])
  }, [
    _createElementVNode("form", {
      id: "add-dish-form",
      onSubmit: _withModifiers(handleForm, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Add Dish", -1)),
        _createElementVNode("button", {
          type: "button",
          onClick: hideForm,
          class: "button secondary",
          id: "close_form_button"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] })
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("label", null, "Dish Name", -1)),
      _withDirectives(_createElementVNode("input", {
        maxlength: "50",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
        placeholder: "e.g. Pasta",
        type: "text"
      }, null, 512), [
        [_vModelText, title.value]
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("label", null, "List", -1)),
      _createVNode(DishListSelector, {
        modelValue: list.value,
        onListChange: dishListSelectChangeHandler
      }, null, 8, ["modelValue"]),
      _cache[6] || (_cache[6] = _createElementVNode("label", null, "Description (optional)", -1)),
      _withDirectives(_createElementVNode("textarea", {
        maxlength: "200",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
        placeholder: "e.g. A simple pasta dish with tomato sauce"
      }, null, 512), [
        [_vModelText, description.value]
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("label", null, "Exposure Goal", -1)),
      _withDirectives(_createElementVNode("input", {
        min: "1",
        max: "99",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((goal).value = $event)),
        placeholder: "e.g. 12",
        type: "number"
      }, null, 512), [
        [
          _vModelText,
          goal.value,
          void 0,
          { number: true }
        ]
      ]),
      _createElementVNode("button", _hoisted_1, [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Add Dish"))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 2))
}
}

})